var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('subnavbar-ventas'),_c('router-view',{attrs:{"config":"config","payment-methods":"payment_methods"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }